<template>
    <div class="login">
        <div class="login_body">
            <el-row>
                <el-col :span="12" class="login_body_left">
                    <img src="../../static/img/typocheck_login_1.png" alt="" />
                </el-col>
                <el-col :span="12" class="login_body_right">
                    <div>
                        <ul>
                            <li style="cursor: pointer">
                                <span style="margin-right: 28px" @click="login_fun(1, true)" :class="{ show_berder: show_class == 1 }">登录</span>
                                <span @click="login_fun(2, false)" :class="{ show_berder: show_class == 2 }" v-if="$root.clientType !== 1">注册</span>
                            </li>
                            <li>
                                <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
                                    <div style="margin-top: 20px" v-show="login_show">
                                        <el-form-item prop="nickName">
                                            <el-input v-model="ruleForm.nickName" placeholder="请输入手机号或用户名" maxlength="11">
                                                <i slot="prefix" class="el-icon-user"></i>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item prop="pass">
                                            <el-input type="password" v-model="ruleForm.pass" show-password autocomplete="off" placeholder="请输入密码">
                                                <i slot="prefix" class="el-icon-lock"></i>
                                            </el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="rights" v-show="!login_show">
                                        <!-- <el-radio style="margin-bottom: 14px" v-model="regUserType" label="1">个人用户</el-radio> -->
                                        <!-- <el-radio style="margin-bottom: 14px" v-model="regUserType" label="2">单位用户</el-radio> -->
                                        <!-- <el-form-item prop="nickName2" v-show="!login_show && regUserType == 1">
                                            <el-input v-model="ruleForm.nickName2" placeholder="请输入昵称/姓名" maxlength="20" @change="onNickName2Change">
                                                <i slot="prefix" class="el-icon-user"></i>
                                            </el-input>
                                        </el-form-item> -->
                                        <el-form-item prop="userName" v-show="!login_show && regUserType == 1">
                                            <el-input v-model="ruleForm.userName" placeholder="请输入登录用户名" maxlength="20" @change="onUsernameChange" autocomplete="off">
                                                <i slot="prefix" class="el-icon-user"></i>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item prop="nickName3" v-show="!login_show && regUserType == 2">
                                            <el-input v-show="regUserType == 2" v-model="ruleForm.nickName3" placeholder="请输入单位名称" maxlength="20" @change="onNickName3Change">
                                                <i slot="prefix" class="el-icon-user"></i>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item prop="phone">
                                            <el-input v-model.number="ruleForm.phone" placeholder="请输入手机号" maxlength="11" @change="onPhoneInputChange">
                                                <i slot="prefix" class="el-icon-mobile"></i>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item prop="pass">
                                            <el-input type="password" v-model="ruleForm.pass" autocomplete="new-password" show-password clearable placeholder="输入6-18位数字或英文字符组合的密码" @change="onPasswordChange">
                                                <i slot="prefix" class="el-icon-lock"></i>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item prop="checkPass" v-show="!login_show">
                                            <el-input type="password" v-model="ruleForm.checkPass" show-password clearable autocomplete="new-password" placeholder="请确认密码" @change="onCheckPassChange">
                                                <i slot="prefix" class="el-icon-lock"></i>
                                            </el-input>
                                        </el-form-item>
                                        <!-- 手机验证吗 -->
                                        <el-form-item prop="ssmcode" style="text-align: left" v-show="!login_show">
                                            <el-input type="text" v-model="ruleForm.ssmcode" placeholder="输入验证码" style="width: 60%" @change="onSsmCodeChange"></el-input>
                                            <span v-show="!sendAuthCode" style="color: red; font-size: 14px; margin-left: 55px">{{ buttonName }}</span>
                                            <span v-show="sendAuthCode" @click="getAuthCode()" style="margin-left: 30px; cursor: pointer">获取验证码</span>
                                        </el-form-item>
                                    </div>
                                </el-form>

                                <div>
                                    <el-button type="primary" @click="submitLogin(ruleForm, 'ruleForm')" v-show="login_show" :loading="loginLoading">登录</el-button>
                                    <el-button style="margin: 0px 0px 15px" type="primary" @click="submitForm(ruleForm, 'ruleForm')" v-show="!login_show">注册</el-button>
                                </div>

                                <p v-show="login_show" @click="goreset()" style="color: #0e74dd; text-align: right; margin: 5px; cursor: pointer;">忘记密码 ?</p>
                                <p v-show="!login_show" style="text-align: left; margin-left: 10px; margin-bottom: 5px;">
                                    <el-checkbox v-model="signDisclaimers">我已阅读并同意</el-checkbox>
                                    <span style="color: blue; cursor: pointer;" @click="dlgMzsmVisible=true">免责声明</span>
                                </p>
                                <p v-show="!login_show">
                                    <span style="color: #999">已有账户 ? </span>
                                    <span style="color: #95a0e3; cursor: pointer" @click="login_fun(1, true)">直接登录</span>
                                </p>
                            </li>
                        </ul>
                        <el-dialog :visible.sync="dlgMzsmVisible" width="550px" style="text-align: left">
                            <div slot="title" style="font-size: 18px" class="dialog-title">
                                <i class="el-icon-warning" style="color: #ff8d00; font-size: 20px; margin-right: 6px"></i>
                                <span class="title-text">免责声明</span>
                                <div class="button-right">
                                    <span class="title-close" @click="dlgMzsmVisible = false"></span>
                                </div>
                            </div>
                            <div style="font-size: 16px; line-height: 25px">
                                蓝猫审核提供的全部审核结果均为机器审核，未经人工审核。审核结果仅供参考，无法保证结果的完全准确。北京沃度信息科技有限公司对审核结果不承担相应的法律责任。同时，也欢迎您提出宝贵建议，帮助我们不断优化审核能力。
                            </div>
                            <span slot="footer" class="dialog-footer">
                                <el-button type="primary" @click="dlgMzsmVisible=false; signDisclaimers=true;">确 定</el-button>
                            </span>
                        </el-dialog>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- <p style="text-align: center; width: 100%; margin-top: 75px" v-if="this.$root.clientType === 0">
            © <a href="http://www.cmsmate.com.cn/" title="v 1.1.3">cmsmate</a>
        </p> -->
    </div>
</template>
// <script src="../../static/js/kefu.js"></script>

<script>
import getUserIP from "./utils";
import { getToken } from "@/utils/auth";
import { setToken } from "@/utils/auth";
import { aad } from "@/utils/auth";
import store from "@/store";
// import { kefu } from "../../static/js/kefu.js"

export default {
    data() {
        var getName2 = (rule, value, callback) => {
            if (!value) { return callback(new Error("昵称不能为空")); }
            else { callback(); }
        };
        var getName3 = (rule, value, callback) => {
            if (!value) { return callback(new Error("单位名称不能为空")); }
            else { callback(); }
        };
        var getName = (rule, value, callback) => {
            console.log(rule, value, callback);
            if (!value) { return callback(new Error("请输入用户名或手机号")); }
            else { callback(); }
        };
        var getUserName = (rule, value, callback) => {
            if (!value) { return callback(new Error('请输入用户名')) }
            else callback()
        }
        var validatePass = (rule, value, callback) => {
            if (value.replace(/\s+/g, "") === "") {
                callback(new Error("请输入密码"));
            // } else if (value.length < 6) {
            //     callback(new Error("请输入6-18位数字或英文字符组合"));
            // } else if (value.length > 18) {
            //     callback(new Error("请输入6-18位数字或英文字符组合"));
            } else if (!/^[A-Za-z0-9]{6,18}$/.test(value)) {
                callback(new Error("请输入6-18位数字或英文字符组合"));
            } else {
                // if (this.ruleForm.checkPass.replace(/\s+/g, "") !== "") {
                //   this.$refs.ruleForm.validateField("checkPass");
                // }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value.replace(/\s+/g, "") === "") {
                callback(new Error("请再次输入密码,不能使用空格"));
            } else if (value.replace(/\s+/g, "") !== this.ruleForm.pass) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        var checkPhone = (rule, value, callback) => {
            let reg = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;
            if (!value) {
                this.shows = false;
                return callback(new Error("手机号不能为空"));
            } else if (!reg.test(value)) {
                this.shows = false;
                return callback(new Error("手机号格式不正确，请重新输入"));
            } else {
                this.shows = true;
                callback();
            }
        };
        var ssmCode = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("验证码不能为空"));
            } else {
                const reg = /^\d{6}$/;
                // console.log(reg.test(value),"jhfh");
                if (reg.test(value)) {
                    callback();
                } else {
                    return callback(new Error("请输入正确的验证码"));
                }
            }
        };
        return {
            loginLoading: false,
            ip: "",
            regUserType: "1",
            second: 60,
            buttonName: "",
            shows: true,
            todaydate: "", //当前时间
            todaydatekey: "", //当前时间戳
            ruleForm: {
                nickName: "",
                nickName2: "",
                nickName3: "",
                pass: "",
                checkPass: "",
                phone: "",
                ssmcode: "",
            },
            rules: {
                nickName: [ { validator: getName, trigger: "change-" } ],
                nickName2: [ { validator: getName2, trigger: "change-" } ],
                nickName3: [ { validator: getName3, trigger: "change-" } ],
                userName: [ { validator: getUserName, trigger: 'change-' } ],
                pass: [ { validator: validatePass, trigger: "change-" } ],
                checkPass: [ { validator: validatePass2, trigger: "change-" } ],
                phone: [ { validator: checkPhone, trigger: "change-" } ],
                // 匹配验证码
                ssmcode: [ { validator: ssmCode, trigger: "change-" } ],
            },
            show_class: "1",
            login_show: true,
            sendAuthCode: true,
            //创建一个localData，用来接收存储的数据
            localData: "",
            signDisclaimers: false,  // 是否勾选免责声明
            dlgMzsmVisible: false,   // 是否显示免责声明对话框
        };
    },
    methods: {
        login_fun(num, Bool) {
            console.log(parseInt(num) == 1 ? '点登录' : '点注册')
            this.show_class = num;
            this.login_show = Bool;
            this.ruleForm = { nickName: "", nickName2: '', nickName3: '', pass: "", checkPass: "", phone: "", ssmcode: "" };
        },
        submitForm(formName, formName2) {
            this.registered();
            // if (this.show_class != 1) {
            //   this.$refs[formName2].validate((valid) => {
            //     console.log(this.$refs, "k4545", valid, "1");
            //     if (valid) {
            //       this.repeat();
            //     } else {
            //       const h = this.$createElement;
            //       this.$notify({
            //         title: "警告",
            //         message: h(
            //           "i",
            //           {
            //             style: "color: teal",
            //           },
            //           "输入不正确,请从新输入,密码中不得有空格"
            //         ),
            //         type: "warning",
            //       });
            //       return false;
            //     }
            //   });
            // } else {
            //   const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
            //   if (reg.test(this.$refs[formName2].fields[0].fieldValue) == false) {
            //     const h = this.$createElement;
            //     this.$notify({
            //       title: "警告",
            //       message: h(
            //         "i",
            //         {
            //           style: "color: teal",
            //         },
            //         "账号或密码不正确"
            //       ),
            //       type: "warning",
            //     });
            //   } else if (
            //     this.$refs[formName2].fields[1].fieldValue.replace(/\s+/g, "") == ""
            //   ) {
            //     const h = this.$createElement;
            //     this.$notify({
            //       title: "警告",
            //       message: h(
            //         "i",
            //         {
            //           style: "color: teal",
            //         },
            //         "账号或密码不正确"
            //       ),
            //       type: "warning",
            //     });
            //   }
            // }
        },
        //登录
        submitLogin(formName, formName2) {
            if (this.ruleForm.nickName == '' || this.ruleForm.pass == '') {
                this.$message({ type: 'error', message: '请输入用户名和密码后再点击登录' })
                return
            }
            var pass = this.$md5(this.ruleForm.pass);
            // this.ip = returnCitySN["cip"];
            console.log(this.baseURL);
            var baseURL = "";
            this.loginLoading = true
            this.$axios.post("/cmsMateService/servlet/LoginForCheck", {
                username: this.ruleForm.nickName,
                password: pass.toUpperCase(),
                // ip: this.ip,
            }).then((res) => {
                console.log(res.data.info, res.data.result, "111111111111");
                if (res.data.result !== "200") {
                    if(res.data.message == '参数缺失') this.$message({type: 'warning', message: '请输入用户名和密码进行登录'})
                    else this.$message({type: 'warning', message: res.data.message})
                    this.ruleForm.pass = "";
                } else if (res.data.result == "200") {
                    // usertype用户级别 (0管理员 1普通用户 2高级用户 3VIP用户)
                    sessionStorage.setItem("status", res.data.info.userType),
                    sessionStorage.setItem("nickname", res.data.info.nickname);
                    sessionStorage.setItem("username", res.data.info.username),
                    sessionStorage.setItem("appkey", res.data.info.appkey),
                    sessionStorage.setItem("flag", res.data.info.flag);
                    sessionStorage.setItem("lastLogin", res.data.info.lastLogin);
                    sessionStorage.setItem("remainNum", res.data.info.remainNum);
                    sessionStorage.setItem("endTime", res.data.info.endTime);
                    sessionStorage.setItem("remainNum", res.data.info.remainNum);
                    sessionStorage.setItem("userId", res.data.info.userId);
                    sessionStorage.setItem("genre", res.data.info.genre);
                    sessionStorage.setItem("canAdd", res.data.info.canAdd);
                    sessionStorage.setItem("creatorId", res.data.info.creatorId);

                    if (parseInt(sessionStorage.getItem('status')) > 1 || this.$root.clientType === 1) {    // 高级用户与VIP用户才可以自定义
                        // 登录成功，开始获取用户自定义的顶部样式
                        this.$axios.post('/cmsMateService/login.do?method=achieveUserConfig', {
                            'userId': res.data.info.userId
                        }).then(res => {
                            if (res.status === 200 && parseInt(res.data.result) === 200) {
                                this.$store.commit('setUserConfig', [res.data.info.title, res.data.info.logoPath, res.data.info.height, res.data.info.backgroundColor])
                                if (res.data.info.title && res.data.info.title.length > 0) {
                                    document.title = res.data.info.title
                                }
                                // 保存用户配置到session中
                                sessionStorage.setItem('user_title', res.data.info.title)
                                sessionStorage.setItem('user_logo', res.data.info.logoPath)
                                sessionStorage.setItem('user_logo_height', res.data.info.height)
                                sessionStorage.setItem('user_top_bc', res.data.info.backgroundColor)
                            } else {
                                this.$message({ message: '用户自定义配置加载失败', type: 'error' })
                            }
                            this.loginLoading = false
                            this.$router.push('/home')
                        }).catch(error => {
                            this.$message({ message: '获取用户配置异常', type: 'error' })
                            this.loginLoading = false
                        })
                    }
                    else {
                        this.loginLoading = false
                        this.$router.push("/home");
                    }
                }
                this.loginLoading = false
            }).catch((error) => {
                this.loginLoading = false
                console.log(error.message);
            });
        },
        goreset() { this.$router.push("/reset"); },
        // 通过主页的时间差值报存 重新获取时间
        timeacive() {
            var nowdate = new Date().valueOf();
            var delt = sessionStorage.getItem("datex"); //设置时间错的差值
            var stap = parseInt(delt) + parseInt(nowdate);
            sessionStorage.setItem("time", stap);
            // this.registered();//zhuce
        },
        // 间接调用注册接口 防止别的用时间也回调用注册接口
        repeat() {
            this.registered();
        },
        // 短信验证
        yzm() {
            this.$axios.post("/api/validateSMSCode", {
                phone: this.ruleForm.phone,
                smsCode: this.ruleForm.ssmcode,
            }, {
                headers: {
                    appToken: getToken(),
                    appTime: sessionStorage.getItem("time"),
                    sign: aad(),
                }, //设置header信息
            }).then((res) => {
                if (res.data.result == 200) {
                    this.registered();
                } else {
                    this.$message({ showClose: true, message: res.data.message, type: "error" });
                }
            }).catch((error) => {
            console.log(error.message);
            });
        },
        // 注册接口
        registered() {
            console.log('准备提交注册')
            if (this.signDisclaimers !== true) {
                this.$message({ type: 'warning', message: '请先阅读并同意免责声明' })
                return
            }
            var checkFields = ['userName', 'phone', 'pass', 'checkPass', 'ssmcode' ]
            Promise.all(checkFields.map((field) => {
                return new Promise((resolve, reject) => {
                    this.$refs['ruleForm'].validateField(field, (errorMsg) => {
                        resolve(errorMsg)
                    })
                })
            })).then((errorMsg) => {
                // console.log(typeof(errorMsg), errorMsg)
                var errorNum = 0
                for (var i = 0; i < errorMsg.length; i++) {
                    if (errorMsg[i] != '') { console.log('验证结果：', errorMsg[i]); errorNum += 1 }
                }
                if (errorNum > 0) { console.log('验证不通过'); return }
                else {
                    // 开始提交
                    var pass = this.$md5(this.ruleForm.pass);
                    this.$axios.post("/cmsMateService/login.do?method=regi", {
                        phone: this.ruleForm.phone,
                        password: pass.toUpperCase(),
                        smsCode: this.ruleForm.ssmcode,
                        nickname: this.ruleForm.userName,// parseInt(this.regUserType) == 1 ? this.ruleForm.nickName2 : this.ruleForm.nickName3,
                        username: this.ruleForm.userName,
                        genre: this.regUserType,
                    }).then((res) => {
                        console.log('注册结果：', res);
                        if (parseInt(res.data.result) != 200) { this.$message({ showClose: true, message: res.data.message, type: 'error' }) }
                        else {
                            console.log('注册成功')
                            this.$message({ type: 'success', message: '注册成功' })
                            this.ruleForm.nickName = '' // parseInt(this.regUserType) == 1 ? this.ruleForm.nickName2 : this.ruleForm.nickName3
                            this.ruleForm.pass = ''
                            this.show_class = 1;
                            this.login_show = true;
                        }
                    }).catch((error) => {
                        console.log(error.message);
                    });
                }
            })
        },
        // 短信接口
        getAuthCode() {
            console.log('准备获取短信验证码')
            var checkFields = ['phone', 'pass', 'checkPass' ]
            Promise.all(checkFields.map((field) => {
                return new Promise((resolve, reject) => {
                    this.$refs['ruleForm'].validateField(field, (errorMsg) => {
                        resolve(errorMsg)
                    })
                })
            })).then((errorMsg) => {
                // console.log(typeof(errorMsg), errorMsg)
                var errorNum = 0
                for (var i = 0; i < errorMsg.length; i++) {
                    if (errorMsg[i] != '') { console.log('验证结果：', errorMsg[i]); errorNum += 1 }
                }
                if (errorNum > 0) { console.log('验证不通过'); return }
                else {
                    console.log('验证通过，开始请求获取验证码')
                    this.$axios.post("/cmsMateService/login.do?method=achieveSMSCode", {
                        phone: this.ruleForm.phone,
                    }).then((res) => {
                        console.log('验证码请求完成：', res);
                        if (res.data.result == 200) {
                            this.$message({ showClose: true, message: res.data.message, type: "success" });
                            this.sendAuthCode = false;
                            this.second = 60;
                            this.getCode();
                        } else {
                            this.$message({ showClose: true, message: res.data.message, type: "error" });
                        }
                        console.log(res.data.result, "短信");
                    }).catch((error) => {
                        console.log(error.message);
                    });
                }
            })
        },
        getCode() {
            let that = this;
            let interval = window.setInterval(function () {
                that.buttonName = that.second + "s";
                --that.second;
                if (that.second < 0) {
                    that.sendAuthCode = true;
                    that.second = 60;
                    window.clearInterval(interval);
                    // that.getCode();
                }
            }, 1000);
        },
        onPhoneInputChange (val) { if (val.length > 0) { this.$refs['ruleForm'].validateField('phone') } },
        onNickName2Change (val) { if (val.length > 0) { this.$refs['ruleForm'].validateField('nickName2') } },
        onNickName3Change (val) { if (val.length > 0) { this.$refs['ruleForm'].validateField('nickName3') } },
        onUsernameChange (val) { if (val.length > 0) { this.$refs['ruleForm'].validateField('userName') } },
        onPasswordChange (val) { if (val.length > 0) { this.$refs['ruleForm'].validateField('pass') } },
        onCheckPassChange (val) { if (val.length > 0) { this.$refs['ruleForm'].validateField('checkPass') } },
        onSsmCodeChange (val) { if (val.length > 0) { this.$refs['ruleForm'].validateField('ssmcode') } }
    },
    created() {},
    // 计时器的使用 防止时间戳过期 如果快60 慢60 都会过期
    mounted() {
        if (sessionStorage.getItem("id")) {
            // 已经登陆
            window.sessionStorage.clear();
            window.localStorage.clear();
            location.reload();
        }
        if (this.$route.query.type == 1) {
            this.login_fun(2, false);
        }
    },
    beforeDestroy() {
        // clearInterval(this.timer)
    },
};
</script>
<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  background: #f0f8ff9e;
  background-size: 100% 100%;
  // height: 0px;
  .login_body {
    width: 1115px;
    margin: auto;
    .login_body_left {
      img {
        width: 548px;
        padding-top: 215px;
        margin-right: 40px;
      }
    }
    /deep/ .login_body_right {
      width: 440px;
      height: 580px;
      float: right;
      border-radius: 15px;
      background: #fff;
      margin-top: 198px;
      box-shadow: 5px 5px 10px 10px rgba(0, 0, 0, 0.1);
      ul {
        li:nth-child(1) {
          height: 77px;
          border-bottom: 1px solid #ccc;
          font-size: 22px;
          padding: 18px 0;
          display: flex;
          justify-content: center;
          span:last-child {
            float: right;
          }
          .show_berder {
            padding-bottom: 4px;
            border-bottom: 3px solid #6583dc;
          }
          span:hover {
            padding-bottom: 4px;
            border-bottom: 3px solid #6583dc;
          }
        }
        li:last-child {
          width: 361px;
          margin: auto;
          padding-top: 38px;
          box-sizing: border-box;
          .el-icon-lock,
          .el-icon-mobile,
          .el-icon-user {
            font-size: 22px !important;
            color: black;
            padding-top: 10px;
            padding-left: 3px;
          }
          .el-button {
            width: 361px;
            border-radius: 22px;
            background-color: #6584d9;
            font-size: 20px;
            margin: 51px 0 15px 0;
          }
          p {
            span:nth-child(1) {
              color: #95a0e3;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
/deep/.el-form-item {
  margin-bottom: 40px;
}
/deep/.rights {
  margin-top: -22px;
  .el-form-item {
    margin-bottom: 17px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue